(() => {
  angular
    .module('complianceFrameworkApp.socialMediaCompliance')
    .controller('StatusUpdatesController', StatusUpdatesController);

  /* ngInject */
  function StatusUpdatesController($state, Flash, sessionService, statusUpdateService) {
    const vm = this;

    vm.deleteStatusUpdate = deleteStatusUpdate;
    vm.pendingStatusUpdates = [];
    vm.recentStatusUpdates = [];

    activate();

    function activate() {
      getStatusUpdates();
    }

    function deleteStatusUpdate(statusUpdate) {
      statusUpdateService(sessionService.getAuthToken()).destroy({ id: statusUpdate.id }, _ => {
        $state.reload();
        Flash.create('success', 'Status update successfully deleted.');
      }, _ => {
        Flash.create('danger', 'An error occurred with the deleting the status update.');
      });
    }

    function getStatusUpdates() {
      statusUpdateService(sessionService.getAuthToken()).recent(response => {
        vm.recentStatusUpdates = response;
      });

      statusUpdateService(sessionService.getAuthToken()).pending(response => {
        vm.pendingStatusUpdates = response;
      });
    }
  }
})();
